import cx from 'classnames'

import styles from './index.module.scss'

interface PlainButtonProps {
  label: string
  active?: boolean
  type?: 'button' | 'submit' | 'reset' | undefined
  btnType?: 'plain' | 'contained'
  color?: 'default' | 'primary' | 'light-primary' | 'orange'
  onClick?: () => void
  style?: object
  icon?: JSX.Element
  textStyle?: string
  className?: string
  disabled?: boolean
  'data-cy'?: string
}

export function PlainButton ({
  label,
  active,
  type = 'button',
  btnType = 'plain',
  color = 'default',
  onClick,
  style = {},
  icon,
  textStyle,
  className,
  disabled = false,
  'data-cy': cy
}: PlainButtonProps): JSX.Element {
  let btnStyles = style

  if (icon) {
    btnStyles = {
      ...style
      // display: 'flex'
    }
  }

  return (
    <button
      type={type}
      className={cx(styles.plainButton, className, {
        // TODO: sort things out with typescript-plugin-css-modules
        [styles.active as string]: active,
        [styles.disabled as string]: disabled,
        [styles.contained as string]: btnType === 'contained',
        [styles.primaryBg as string]: color === 'primary',
        [styles.lightPrimaryBg as string]: color === 'light-primary',
        [styles.orange as string]: color === 'orange'
      })}
      onClick={onClick}
      style={btnStyles}
      data-cy={cy ?? `plain-button-${label}`}
      disabled={disabled}
    >
      <div className={icon ? 'flex items-center' : ''}>
        {icon && <div className='mr-4'>{icon}</div>}
        <p className={textStyle ?? ''}>{label}</p>
      </div>
    </button>
  )
}
